import RadioTab from '3-components/RadioTab/RadioTab';
import RadioTabItem from '3-components/RadioTab/RadioTabItem';
import type { FC } from 'react';
import { searchResultsTypes } from './SearchBlock';

interface SearchFiltersProps {
    selectedSearchType: string | null;
    setSelectedSearchType: (type: string) => void;
    searchTypes: { title: string; count: number }[];
}

const SearchFilters: FC<SearchFiltersProps> = ({ selectedSearchType, setSelectedSearchType, searchTypes }) => {
    const totalCount = searchTypes.reduce((sum, type) => {
        return sum + type.count;
    }, 0);

    return (
        <div className="search-block-sidebar">
            <RadioTab fullWidth={true} cols="1-lg">
                <RadioTabItem
                    key="all"
                    icon="language"
                    suffixText={totalCount.toString()}
                    label="All"
                    id="all"
                    name="all"
                    value="all"
                    checked={!selectedSearchType}
                    onChange={(): void => {
                        setSelectedSearchType('');
                    }}
                />
                {searchResultsTypes.map((searchResultType, i) => {
                    const searchType = searchTypes.find(type => {
                        return type.title === searchResultType;
                    });
                    const count = searchType ? searchType.count : 0;

                    return (
                        <RadioTabItem
                            key={searchResultType}
                            icon="language"
                            suffixText={count.toString()}
                            label={searchResultType}
                            id={`${searchResultType}-${i}`}
                            name={searchResultType}
                            value={searchResultType}
                            checked={selectedSearchType?.toLowerCase() === searchResultType.toLowerCase()}
                            onChange={(e): void => {
                                setSelectedSearchType(e.target.value);
                            }}
                        />
                    );
                })}
            </RadioTab>
        </div>
    );
};

export default SearchFilters;
